// material.module.ts

import { NgModule } from '@angular/core';

import {
  MatCheckboxModule,
  MatFormFieldModule,
  MatInputModule,
  MatCardModule,
  MatButtonModule,
//   ///////////////////
  MatExpansionModule,
  MatGridListModule,
  MatTableModule,
  MatPaginatorModule,
  MatMenuModule,
  MatRadioModule,
  MatTooltipModule, 
  MatSelectModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatAutocompleteModule,
  MatIconModule,
  MatSliderModule,
  MatTabsModule

} from '@angular/material';

import {MatSelectInfiniteScrollModule} from 'ng-mat-select-infinite-scroll';

@NgModule({
  imports: [
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatSelectModule,
    MatSelectInfiniteScrollModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTabsModule
  ],
  exports: [
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    // ///////////////
    MatExpansionModule,
    MatGridListModule,
    MatSliderModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatRadioModule,
    MatTooltipModule,
    MatSelectModule,
    MatSelectInfiniteScrollModule,
    MatDialogModule,
    MatIconModule
  ]
})

export class MaterialModule { }